import { useQuery } from "@tanstack/react-query";
import { PageLoader } from "components";
import { FC, PropsWithChildren, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { translationServiceRequest } from "services/api";
import i18n from "i18next";

interface Props {}

const paramEntries: Record<string, "uz" | "lat" | "ru"> = {
    uz: "uz",
    lat: "lat",
    ru: "ru",
};

const STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
const DEFAULT_LANG = "uz_cyrl";
const projectId = process.env.REACT_APP_TRANSLATION_SERVICE_PROJECT_ID;

const TranslationWrapper: FC<PropsWithChildren<Props>> = ({ children }) => {
    const { addResourceBundle, language = DEFAULT_LANG } = i18n;

    const { isFetching, isLoading } = useQuery({
        queryKey: ["/translation/get-all", language],
        staleTime: STALE_TIME_MS,
        queryFn: () =>
            translationServiceRequest.get("/translation/get-all-by-language", {
                params: {
                    lang: paramEntries?.[language],
                    projectId,
                },
                auth: {
                    username: "dev-tax-translation",
                    password: "tax@txt$132",
                },
            }),
        onSuccess(response) {
            addResourceBundle(language, "translation", response?.data, false, true);
        },
    });

    return (
        <Fragment>{isLoading || isFetching ? <PageLoader /> : children}</Fragment>
    );
};

export default withTranslation()(TranslationWrapper);
